const o = "CommonMessage";
export {
  o as COMMON_MESSAGE_DTI
};
//# sourceMappingURL=CommonMessage.consts.mjs.map
